export const isBicRequired = (iban: string | undefined) => {
  return iban && !iban.startsWith('CH')
}
